import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export type SupportedLanguage = 'en' | 'sw' | 'fr'

export interface LanguageOption {
  code: SupportedLanguage
  name: string
  flag: string
}

export const useLanguageStore = defineStore('language', () => {
  const currentLanguage = ref<SupportedLanguage>('en')
  
  const availableLanguages: LanguageOption[] = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'sw', name: 'Swahili', flag: '🇹🇿' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' }
  ]

  const currentLanguageOption = computed(() => 
    availableLanguages.find(lang => lang.code === currentLanguage.value)
  )

  const setLanguage = (languageCode: SupportedLanguage) => {
    currentLanguage.value = languageCode
    localStorage.setItem('preferred-language', languageCode)
  }

  const initializeLanguage = () => {
    const stored = localStorage.getItem('preferred-language') as SupportedLanguage
    const browserLang = navigator.language.toLowerCase()
    
    if (stored && availableLanguages.some(lang => lang.code === stored)) {
      currentLanguage.value = stored
    } else if (browserLang.startsWith('sw') || browserLang.includes('tanzania')) {
      currentLanguage.value = 'sw'
    } else if (browserLang.startsWith('fr')) {
      currentLanguage.value = 'fr'
    } else {
      currentLanguage.value = 'en'
    }
  }

  return {
    currentLanguage,
    availableLanguages,
    currentLanguageOption,
    setLanguage,
    initializeLanguage
  }
})